import React from "react";

import { CTALink, InlineText } from "../Text/styled";
import { ButtonTypes, ButtonSizes } from "./types";
import { StyledButton } from "./styled";
import { Loader } from "semantic-ui-react";
import { TColor } from "../../theme";

export interface ButtonProps {
  styleType?: ButtonTypes;
  $size?: ButtonSizes;
  width?: string;
  height?: number;
  showLoader?: boolean;
  type?: "button" | "submit" | "reset";
  bgColor?: string;
  borderColor?: string;
}

const Button: React.FunctionComponent<
  ButtonProps & Omit<React.HTMLProps<HTMLButtonElement>, "ref" | "as">
> = ({
  styleType = "primary",
  showLoader = false,
  children,
  type = "button",
  $size,
  ...rest
}) => {
  const getTextColor = (): TColor => {
    switch (styleType) {
      case "primary":
      case "blue":
        return "white";
      case "transparent":
        return "blue";
      case "secondary-inverted":
        return "graySolid6";
      case "purple-blue":
        return "white";
    }
    return "primary";
  };

  const getText = () => {
    if ($size === "xsmall") {
      return (
        <InlineText
          $color={getTextColor()}
          $size="16px"
          $onHoverColor="currentColor"
        >
          {children}
        </InlineText>
      );
    }
    return <CTALink color={getTextColor()}>{children}</CTALink>;
  };

  let Component = (
    <StyledButton {...rest} styleType={styleType} type={type} $size={$size}>
      {showLoader ? <Loader size="medium" active /> : getText()}
    </StyledButton>
  );
  if (rest.href) {
    Component = (
      <a href={rest.href} target={rest.target}>
        {Component}
      </a>
    );
  }
  return Component;
};

export default Button;
